// src/pages/post/Home.jsx
import React from 'react';
import Posts from '../../components/post/Posts';

const Home = () => {
  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="pt-8 pb-16">
        {/* Hero section */}
        <div className="container mx-auto px-4 mb-12">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
              Discover Interesting Stories and Ideas
            </h1>
            <p className="text-xl text-gray-600 mb-8">
              Explore a diverse collection of articles, insights, and perspectives from our community of writers.
            </p>
          </div>
        </div>
        
        {/* Featured categories */}
        <div className="container mx-auto px-4 mb-12">
          <div className="flex flex-wrap justify-center gap-3">
            {["All", "Technology", "Business", "Health", "Education", "Entertainment"].map(category => (
              <a 
                key={category}
                href={category === "All" ? "/" : `/posts/categories/${category}`}
                className="px-4 py-2 rounded-full bg-white shadow-sm hover:bg-primary hover:text-white transition-colors"
              >
                {category}
              </a>
            ))}
          </div>
        </div>
        
        {/* Posts grid */}
        <Posts />
      </div>
    </div>
  );
};

export default Home;